import azure from "../certificates/azure-microsoft.png";
import coursera1 from "../certificates/coursera-1.png";
import coursera2 from "../certificates/coursera-2.png";
import coursera3 from "../certificates/coursera-3.png";
import css from "../certificates/css-hackerrank.png";
import dsa from "../certificates/dsa.jpg";
import fullStack from "../certificates/Full-Stack.jpg";
import google from "../certificates/google.png";
import guvi1 from "../certificates/guvi-certificate-guiness.png";
import guvi2 from "../certificates/guvi-guiness.png";
import java from "../certificates/java-great-learning.png";
import problemsolving from "../certificates/problem-solving-hackerrank.png";
import progate from "../certificates/progate.png";
import pythonHackerrank from "../certificates/python-hackerrank.png";
import reactRedux from "../certificates/react-redux.png";
import iitKanpur from "../certificates/soft-skills-iit-kanpur.png";
import sql from "../certificates/sql-hackerrank.png";
import tcs from "../certificates/TCS-iON.png";
import workshop from "../certificates/technovids-front-end-dev.png";
import walmartIntern from "../certificates/walmart-intern.png";
import sdlc from "../certificates/sdlc.jpg";
import crm from "../certificates/crm.jpg";
import salesforce101 from "../certificates/salesforce101.jpg";
import htmlcss from "../certificates/html5-css3.jpg";
import js from "../certificates/js-fundamentals.jpg";
import javaOOP from "../certificates/oop-java.jpg";
import databases from "../certificates/relational-databases.png";
import communicationFoundations from "../certificates/communication-foundations.png";
import businessWritings from "../certificates/business-writing-principles.png";
import betterBusinessWriting from "../certificates/better-business-writing.png";
import plain from "../certificates/plain-language.png";
import first90Days from "../certificates/first-90-days.png";
import effectiveListening from "../certificates/effective-listening.png";
import excel from "../certificates/excel-essentials.png";
import powerpoint from "../certificates/powerpoint-quick-tips.png";
//import platformdevelopercertified from "../certificates/Salesforce_PD1_Certified.png";
import salesforceAIAssociate from "../certificates/Salesforce_AI_Associate.png";
import salesforceAdmin from "../certificates/salesforce_admin.png";
import salesforceDataCloud from "../certificates/dataCloudConsultant.png";
import salesforceJavaScriptDev1 from "../certificates/javaScriptDev1.png";
import salesforceAssociate from "../certificates/associate.png";
import salesforceAISpecialist from "../certificates/aiSpecialist.png";
import healthCloudAP from "../certificates/healthCloudAP.png";

export const certificates = [
  healthCloudAP,
  salesforceJavaScriptDev1,
  salesforceDataCloud,
  salesforceAdmin,
  salesforceAISpecialist,
  salesforceAIAssociate,
  salesforceAssociate,
  fullStack,
  reactRedux,
  sdlc,
  databases,
  javaOOP,
  azure,
  salesforce101,
  walmartIntern,
  dsa,
  iitKanpur,
  crm,
  coursera1,
  js,
  css,
  htmlcss,
  google,
  coursera2,
  fullStack,
  guvi1,
  coursera3,
  java,
  problemsolving,
  progate,
  pythonHackerrank,
  sql,
  tcs,
  workshop,
  guvi2,
  communicationFoundations,
  businessWritings,
  betterBusinessWriting,
  plain,
  first90Days,
  effectiveListening,
  excel,
  powerpoint
];
